import { createSwiper, withResize } from '../../components/swiper-init.js';

// CS swiper stays enabled at desktop (>=992px) and starts on the second
// slide. We tried `loop: true` for infinite swiping but Swiper's loop
// implementation conflicts badly with `slidesPerView: 'auto'` + variable
// slide widths — caused visible jumps at the boundary and silent loop
// disabling above certain `loopAdditionalSlides` values. Reverted to a
// finite-but-clean carousel; the user reaches the natural end with
// prev/next buttons or pagination dots.
export function initSwiperCsWithResize() {
  withResize(() =>
    createSwiper('is--cs', {
      breakpoints: {
        992: { slidesPerView: 'auto', initialSlide: 1 },
      },
    })
  );
}
